let messages =
{
  button: {
    ok: 'Ok',
    continue: 'Fortsæt',
    cancel: 'Annuller',
    yes: 'Ja',
    no: 'Nej',
    create: 'Opret',
    save: 'Gem',
    close: 'Luk',
    delete: 'Slet',
    send: 'Send',
    add: 'Tilføj',
    remove: 'Fjern',
    search: 'Søg',
    reset: 'Nulstil',
    report: 'Rapport',
    media: {
      excel: 'Excel'
    },
    showSource: 'Vis kilde',
    showFormatted: 'Vis formateret'
  },
  boolean: {
    true: 'Ja',
    false: 'Nej'
  },
  filter: 'Filtrer',
  language: {
    en: 'Engelsk',
    da: 'Dansk'
  },
  subscription: {
    none: 'Ingen',
    paid: 'Betalt',
    unpaid: 'Ubetalt',
    cancelled: 'Annulleret'
  },
  userRoles: {
    ADMIN: 'Administrator',
    MEMBER_VIEW: 'Vis medlemmer',
    MEMBER_EDIT: 'Redigér medlemmer',
    MEMBER_ACCOUNTING: 'Redigér medlemskontingenter'
  },
  header: {
    logout: 'Log ud',
    button: {
      endImpersonation: 'Afslut personifikation'
    },
    dialog: {
      preferences: {
        header: 'Præferencer',
        language: 'Sprog'
      }
    }
  },
  sidebar: {
    dashboard: 'Betjeningspanel',
    members: 'Medlemmer',
    users: 'Brugere',
    organizations: 'Organisationer',
    configuration: 'Konfiguration'
  },
  pages: {
    login: {
      button: {
        login: 'Log ind',
        changePassword: 'Skift adgangskode'
      },
      link: {
        forgotPassword: 'Glemt adgangskode'
      },
      newPasswordMessage: 'Venligst indtast en ny adgangskode',
      dialog: {
        forgotPassword: {
          header: 'Glemt adgangskode',
          message: 'Brugernavn',
          button: {
            send: 'Send ny adgangskode'
          },
          error: {
            notFound: 'Brugernavnet \'{userName}\' eksisterer ikke'
          }
        }
      }
    },
    dashboard: {
      welcomeMessage: 'Velkommen til Calasdo'
    },
    organization: {
      button: {
        create: 'Opret ny organisation'
      },
      table: {
        columns: {
          name: 'Navn',
          domainName: 'Domænenavn'
        }
      },
      edit: {
        header: {
          create: 'Ny organisation',
          update: 'Rediger organisation'
        },
        fields: {
          name: 'Navn',
          domainName: 'Domænenavn'
        }
      },
      dialog: {
        delete: {
          header: 'Slet organisation',
          message: 'Er du sikker på at du vil slette \'{name}\'?'
        }
      }
    },
    user: {
      button: {
        create: 'Opret ny bruger',
        resetPassword: 'Nulstil adgangskode',
        impersonate: 'Start personifikation'
      },
      snackbar: {
        resetPassword: {
          succeed: 'Adgangskoden er nustillet',
          failed: 'Kunne ikke nulstille adgangskoden'
        }
      },
      table: {
        columns: {
          userName: 'Brugernavn',
          fullName: 'Navn',
          email: 'E-mail',
          superAdmin: 'Super administrator',
          organization: 'Organisation',
          roles: 'Roller'
        }
      },
      edit: {
        header: {
          create: 'Ny bruger',
          update: 'Rediger bruger'
        },
        fields: {
          userName: 'Brugernavn',
          fullName: 'Navn',
          email: 'E-mail',
          superAdmin: 'Super administrator',
          organization: 'Organisation',
          roles: 'Roller'
        },
        error: {
          inUse: 'Brugernavnet \'{userName}\' eksisterer allerede'
        }
      },
      dialog: {
        resetPassword: {
          header: 'Nulstil adgangkode',
          message: 'Er du sikker på at du vil nulstille adgangskoden for \'{userName}\'?'
        },
        delete: {
          header: 'Slet bruger',
          message: 'Er du sikker på at du vil slette \'{userName}\'?'
        }
      }
    },
    configuration: {
      tabs: {
        global: {
          tabName: 'Global konfiguration',
          intro: 'Dette er den globale konfiguration, som stadig er tom'
        },
        mail: {
          tabName: 'Mail',
          server: {
            header: 'Mail server',
            hostName: 'Servernavn',
            port: 'Port nummer',
            userName: 'Brugernavn',
            password: 'Adgangskode'
          },
          sender: {
            header: 'Afsender / fra',
            name: 'Navn',
            email: 'Email-adresse'
          }
        },
        mailTemplate: {
          tabName: 'Mail skabeloner',
          template: 'Skabelon',
          subject: 'Emne',
          templates: {
            welcome: 'Velkommen',
            resetPassword: 'Nultil adgangskode',
            forgotPassword: 'Glemt adgangskode'
          }
        }
      }
    },
    member: {
      button: {
        openSearch: 'Avanceret søgning',
        showAll: 'Vis alle',
        create: 'Tilføj nyt medlem',
        addSubscription: 'Tilføj kontingent',
        paid: 'Betalt',
        print: 'Print',
        sendEmail: 'Send email',
        copyEmailAddresses: 'Kopiér email-adresser'
      },
      snackbar: {
        copyEmailAddresses: {
          succeed: 'Email-adresser er kopieret til udklipsholder'
        }
      },
      type: {
        private: 'Privat',
        company: 'Erhverv',
        association: 'Forening'
      },
      table: {
        columns: {
          number: 'Nr.',
          name: 'Navn',
          address: 'Adresse',
          phone: 'Telefon',
          email: 'Email',
          subscription: 'Kontingent'
        }
      },
      search: {
        header: 'Søg medlemmer',
        fields: {
          number: 'Nummer',
          firstName: 'Fornavn',
          type: 'Type',
          supportMember: 'Støttemedlem',
          middleName: 'Mellemnavn',
          lastName: 'Efternavn',
          companyName: 'Firmanavn',
          vat: 'CVR nr.',
          associationName: 'Forening',
          email: 'Email',
          phone: 'Telefon',
          mobile: 'Mobil',
          address: 'Adresse',
          location: 'Stednavn',
          zipCode: 'Postnummer',
          city: 'By',
          country: 'Land'
        }
      },
      edit: {
        header: {
          create: 'Tilføj nyt medlem',
          update: 'Redigér medlem'
        },
        fields: {
          number: 'Nummer',
          firstName: 'Fornavn',
          type: 'Type',
          supportMember: 'Støttemedlem',
          middleName: 'Mellemnavn',
          lastName: 'Efternavn',
          companyName: 'Firmanavn',
          vat: 'CVR nr.',
          associationName: 'Forening',
          email: 'Email',
          phone: 'Telefon',
          mobile: 'Mobil',
          address: 'Adresse',
          location: 'Stednavn',
          zipCode: 'Postnummer',
          city: 'By',
          country: 'Land',
          comments: 'Kommentarer',
          subscriptions: 'Kontingenter'
        }
      },
      subscription: {
        table: {
          columns: {
            created: 'Oprettet',
            text: 'Tekst',
            status: 'Status'
          }
        }
      },
      dialog: {
        delete: {
          header: 'Slet medlem',
          message: 'Er du sikker på at du vil slette \'{name}\'?'
        },
        createSubscription: {
          header: 'Opret kontingent',
          text: 'Tekst'
        },
        editSubscription: {
          header: 'Redigér kontingent',
          text: 'Tekst',
          paid: 'Betalt',
          cancelled: 'Annulleret'
        }
      }
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/plugins/i18n/da.js